import { render, staticRenderFns } from "./Changhe.vue?vue&type=template&id=361ea100&scoped=true"
import script from "./Changhe.vue?vue&type=script&lang=js"
export * from "./Changhe.vue?vue&type=script&lang=js"
import style0 from "./Changhe.vue?vue&type=style&index=0&id=361ea100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361ea100",
  null
  
)

export default component.exports